import { ElementType, ReactNode } from 'react';
import { Button } from '../../../components/Button';
import { cn } from '../../../lib/utils';
import { Inbox } from 'lucide-react';

export interface AdminEmptyStateProps {
  title: string;
  description?: string;
  icon?: ElementType;
  action?: {
    label: string;
    onClick: () => void;
    icon?: ElementType;
    variant?: 'primary' | 'secondary' | 'outline';
  };
  children?: ReactNode;
  className?: string;
}

export function AdminEmptyState({
  title,
  description,
  icon: Icon = Inbox,
  action,
  children,
  className,
}: AdminEmptyStateProps) {
  const ActionIcon = action?.icon;

  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center text-center p-8 sm:p-12 border border-dashed border-border rounded-lg bg-card/40 max-w-xl mx-auto my-6',
        className
      )}
    >
      <div className="size-12 rounded-full bg-muted/60 text-muted-foreground flex items-center justify-center mb-4">
        <Icon className="size-6 text-muted-foreground" />
      </div>

      <h3 className="text-base font-semibold font-display text-foreground mb-1">
        {title}
      </h3>

      {description && (
        <p className="text-xs text-muted-foreground max-w-sm mb-5 leading-relaxed">
          {description}
        </p>
      )}

      {action && (
        <Button
          variant={action.variant || 'primary'}
          size="sm"
          onClick={action.onClick}
          className="gap-1.5"
        >
          {ActionIcon && <ActionIcon className="size-3.5" />}
          <span>{action.label}</span>
        </Button>
      )}

      {children}
    </div>
  );
}
